import React, { useCallback, useEffect, useState } from 'react'
import { Col, Container, Row } from 'reactstrap'
import Header from '../components/Header'
import CoreEmpresasList from '../components/core/CoreEmpresasList'
import apiEmpresaService from '../services/apiEmpresaService'
import '../styles/FormView.css'

function CoreView() {
  const [empresas, setEmpresas] = useState([])
  const [isLoadingEmpresas, setIsLoadingEmpresas] = useState(false)
  const [empresasError, setEmpresasError] = useState('')

  const loadEmpresas = useCallback(async () => {
    setIsLoadingEmpresas(true)
    setEmpresasError('')
    try {
      const data = await apiEmpresaService.listEmpresas()
      setEmpresas(Array.isArray(data) ? data : [])
    } catch (error) {
      const message = error?.body?.message || 'No se pudieron cargar las empresas.'
      setEmpresasError(message)
    } finally {
      setIsLoadingEmpresas(false)
    }
  }, [])

  useEffect(() => {
    loadEmpresas()
  }, [loadEmpresas])

  return (
    <>
      <Header />
      <Container fluid className="form-container">
        <Container>
          <div className="form-header">
            <h1>core</h1>
          </div>
          <Row className="justify-content-center mt-4">
            <Col xs={12}>
              <CoreEmpresasList
                empresas={empresas}
                isLoading={isLoadingEmpresas}
                error={empresasError}
                onRefresh={loadEmpresas}
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  )
}

export default CoreView
